import { useMemo } from 'react';
import { encodeQr } from './qr-matrix';

// Renders a QR code as inline SVG — encoded in the browser (qr-matrix.ts), so no
// image request leaves the page. One path for all dark modules keeps the DOM small.
export function QrImage({ value, label, className }: { value: string; label: string; className?: string }) {
  const { size, d } = useMemo(() => {
    const modules = encodeQr(value);
    const quiet = 2;
    let path = '';
    modules.forEach((row, y) =>
      row.forEach((dark, x) => {
        if (dark) path += `M${x + quiet} ${y + quiet}h1v1h-1z`;
      }),
    );
    return { size: modules.length + quiet * 2, d: path };
  }, [value]);

  return (
    <svg className={className} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label} shapeRendering="crispEdges">
      <rect width={size} height={size} fill="#ffffff" />
      <path d={d} fill="#101826" />
    </svg>
  );
}
